import React, { useState } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";


const ProfileMenu = props => {
  const user = JSON.parse(localStorage.getItem("authUser")) || {};
  const [menu, setMenu] = useState(false);
  const [photoFailed, setPhotoFailed] = useState(false);
  const navigate = useNavigate();

  const name =
    user.name || user.username || user.full_name || user.email || "Admin";
  const email =
    user.email ||
    (() => {
      try {
        return JSON.parse(localStorage.getItem("email")) || "";
      } catch {
        return "";
      }
    })();
  const photo =
    user.photo_url ||
    user.profile_image ||
    user.photo ||
    "";
  const roleName = localStorage.getItem("userRole") || "";
  const initial = name.trim().charAt(0).toUpperCase() || "A";
  
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("selected_student");
    localStorage.removeItem("student_selected");
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("primary_mail_id");
    localStorage.removeItem("userRole");
    localStorage.removeItem("email");
    localStorage.removeItem("role"); 
    localStorage.removeItem("activeTab");
    localStorage.removeItem("paymentResponse");
    localStorage.removeItem("selectedStudent");
    localStorage.removeItem("profileImage");

    navigate("/logout");
  };

  return (
    <React.Fragment>
      <div
        onMouseEnter={() => setMenu(true)}
        onMouseLeave={() => setMenu(false)}
        style={{ display: "inline-block" }}
      >
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
          aria-label={`Logged in as ${name}`}
        >
          <span
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "var(--talc-primary, #da7938)",
              color: "#fff",
              fontSize: "15px",
              fontWeight: 700,
              overflow: "hidden",
              flexShrink: 0,
              boxShadow:
                "0 0 0 2px #fff, 0 0 0 4px var(--talc-primary, #da7938)",
            }}
          >
            {photo && !photoFailed ? (
              <img
                src={photo}
                alt={name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                onError={() => setPhotoFailed(true)}
              />
            ) : (
              initial
            )}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <div className="px-3 py-2">
            <div className="fw-bold" style={{ fontSize: "13px", color: "var(--talc-text-primary, #1e293b)" }}>
              {name}
            </div>
            {email && (
              <div className="text-muted" style={{ fontSize: "11px", wordBreak: "break-all" }}>
                {email}
              </div>
            )}
            {roleName && (
              <div
                className="mt-1"
                style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.4px", textTransform: "uppercase", color: "var(--talc-primary, #da7938)" }}
              >
                {roleName}
              </div>
            )}
          </div>
          <div className="dropdown-divider" />
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/change-password">
            <i className="bx bx-key font-size-16 align-middle me-1" />
            {props.t("ChangePassword")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      </div>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
